// Read-only side drawer for release notes (LDCP-186).
// Opens from Help → Release notes in the v2 shell. Content is hard-coded
// for now via releaseNotesContent.js.
import React from "react";
import {
  Box, Stack, Typography, IconButton, Modal, Slide,
} from "@mui/material";
import { ClipboardList } from "lucide-react";

import colors from "../../utils/colors";
import LayerdIcon from "./LayerdIcon";
import { UI_ICONS } from "../../icons/uiLucideIcons";
import { pageDescriptionSx } from "./PageHeader";
import { RELEASE_NOTES } from "./releaseNotesContent";
import ReleaseNoteCard from "./ReleaseNoteCard";

export default function ReleaseNotesDrawer({ open, onClose }) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      BackdropProps={{ sx: { backgroundColor: "rgba(0, 0, 0, 0.5)" } }}
    >
      <Slide direction="left" in={open} mountOnEnter unmountOnExit>
        <Box
          sx={{
            position: "fixed",
            top: 0,
            right: 0,
            width: { xs: "100%", sm: 480 },
            maxHeight: "100vh",
            height: "100vh",
            backgroundColor: "#fff",
            boxShadow: "-4px 0 20px rgba(0,0,0,0.1)",
            zIndex: 1300,
            borderTopLeftRadius: "8px",
            outline: "none",
            border: "none",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box sx={{ px: 3, pt: 3, pb: 2.5, borderBottom: `1px solid ${colors.neutral[200]}`, flexShrink: 0 }}>
            <Stack direction="row" alignItems="flex-start" spacing={1.5}>
              <Box
                sx={{
                  width: 40,
                  height: 40,
                  borderRadius: "8px",
                  backgroundColor: colors.primary[100],
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                  mt: 0.25,
                }}
              >
                <LayerdIcon icon={ClipboardList} size={20} color="primary" />
              </Box>
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Stack direction="row" alignItems="flex-start" justifyContent="space-between" spacing={1}>
                  <Typography sx={{ fontSize: 18, fontWeight: "medium", lineHeight: "24px", color: colors.neutral[1000] }}>
                    Release notes
                  </Typography>
                  <IconButton
                    onClick={onClose}
                    sx={{
                      width: 32,
                      height: 32,
                      borderRadius: "8px",
                      mt: -0.5,
                      flexShrink: 0,
                      "&:hover": { backgroundColor: colors.neutral[50] },
                    }}
                  >
                    <LayerdIcon icon={UI_ICONS.close} size={18} color="neutral" />
                  </IconButton>
                </Stack>
                <Typography sx={{ fontSize: 13, lineHeight: "20px", color: colors.neutral[700], mt: 0.75, pr: 1 }}>
                  See what has changed in recent Layerd updates.
                </Typography>
              </Box>
            </Stack>
          </Box>

          <Box sx={{ flex: 1, minHeight: 0, overflowY: "auto" }}>
            <Stack spacing={3} sx={{ px: 3, pt: 3, pb: 4 }}>
              <Typography sx={pageDescriptionSx}>
                Highlights from recent releases. Full documentation is available from the Help menu.
              </Typography>

              {RELEASE_NOTES.map((release, index) => (
                <ReleaseNoteCard
                  key={release.version}
                  release={release}
                  defaultExpanded={index === 0}
                />
              ))}
            </Stack>
          </Box>
        </Box>
      </Slide>
    </Modal>
  );
}
